import { EllipsisConfig } from 'antd/es/typography/Base';
import Paragraph from 'antd/es/typography/Paragraph';
import { NotifyData } from 'domain/entities/NotifyEntity';
import { useEffect, useState } from 'react';
import { useCollapse } from 'react-collapsed';
import { DATE_FORMAT } from 'utilities/constants/DATE';
import { commonHelpers } from 'utilities/helpers';
import { NotifyLevelComponent } from './NotifyLevel';

interface props {
    data: NotifyData;
    onClick: (id: number) => void;
}

export const CardComponent = ({ data, onClick }: props) => {
    const LINE_HEIGHT = 23;
    const MAX_LINE = 3;
    const MAX_LINE_TITLE = 2;
    const LINE_SPACING = 0;

    const COLLAPSED_HEIGHT = (LINE_HEIGHT + LINE_SPACING) * MAX_LINE;
    const [isShowMore, setIsShowMore] = useState<boolean>(true);
    const [ellipsis, setEllipsis] = useState<boolean | EllipsisConfig>(false);
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({
        collapsedHeight: COLLAPSED_HEIGHT,
    });

    useEffect(() => {
        const el: any = document.getElementById(`content${data.id}`);
        const divHeight = el.offsetHeight;
        const lines = divHeight / LINE_HEIGHT;
        const linesInt = Math.floor(lines);
        setIsShowMore(linesInt > MAX_LINE);
    }, []);

    useEffect(() => {
        if (isExpanded) {
            setEllipsis(false);
        } else {
            setEllipsis({
                rows: MAX_LINE,
            });
        }
    }, [isExpanded]);

    return (
        <section
            className="h-auto card-element w-[100%] md:w-[95%] lg:w-[90%] xl:w-[80%] 2xl:w-[75%] cursor-pointer"
            onClick={() => {
                if (data.alreadyRead === 0) {
                    onClick(data.id);
                }
            }}
        >
            <div className="flex flex-col justify-center p-4 items-start h-full w-full border-b border-b-[#d0d3d8] bg-white">
                {data.alreadyRead === 0 && (
                    <div className="w-full flex justify-end">
                        <svg
                            width={6}
                            height={6}
                            viewBox="0 0 6 6"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx={3} cy={3} r={3} fill="#EB5757" />
                        </svg>
                    </div>
                )}
                <div className="flex flex-col justify-center items-start gap-3 w-full text-left">
                    <div className="flex justify-between items-center gap-2 self-stretch h-5">
                        <NotifyLevelComponent data={data} />
                        <div className="date-time">
                            {commonHelpers.formatDate(
                                data?.noticeDatetime,
                                DATE_FORMAT.FORMAT_SHORT_TIME,
                            )}
                        </div>
                    </div>
                    <div className="w-full label">
                        <Paragraph
                            id={`label-${data.id}`}
                            ellipsis={{
                                rows: MAX_LINE_TITLE,
                            }}
                            className="w-full self-stretch label"
                        >
                            {data.noticeTitle}
                        </Paragraph>
                    </div>
                    <div {...getCollapseProps()}>
                        <Paragraph
                            id={`content${data.id}`}
                            ellipsis={ellipsis}
                            className="w-full self-stretch content"
                        >
                            {data.noticeContents}
                        </Paragraph>
                    </div>
                    {isShowMore && (
                        <div
                            {...getToggleProps()}
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                getToggleProps().onClick(e);
                            }}
                            className="w-full cursor-pointer self-stretch text-[#1f8ddd] text-center font-bold"
                        >
                            {isExpanded ? '閉じる' : 'もっと見る'}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};
